import { render } from "./Privacy.vue?vue&type=template&id=60c32e70&scoped=true"
import script from "./Privacy.vue?vue&type=script&scoped=true&lang=js"
export * from "./Privacy.vue?vue&type=script&scoped=true&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=60c32e70&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c32e70"]])

export default __exports__